import styled from 'styled-components'

import { theme } from '../../../constants'

export const RoutineShell = styled.div`
  width: 100%;
  max-width: ${theme.layout.contentMaxWidth};
  margin: 0 auto;
`

export const RoutineLoading = styled.div`
  min-height: 240px;
  display: grid;
  place-items: center;
  color: ${theme.colors.textSecondary};
`

export const RoutineEmpty = styled.div`
  min-height: 240px;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: ${theme.spacing[2]};
  color: ${theme.colors.textSecondary};
  text-align: center;

  strong {
    color: ${theme.colors.textPrimary};
    font-size: ${theme.typography.size.h3};
  }
`

export const PlayerGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(300px, 0.8fr) minmax(420px, 1.2fr);
  grid-template-rows: minmax(0, auto);
  gap: ${theme.spacing[6]};
  align-items: stretch;

  @media (max-width: ${theme.breakpoints.desktop}) and (orientation: portrait) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }

  @media (max-height: 520px) and (orientation: landscape) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`
